import { Col } from "antd";
import React from "react";
import { useFormContext } from "react-hook-form";
import { ReactSelectField } from "../../../../../atoms/FormElement";
import { getSelectPlaceholderMessage, getValidationProps } from "../../../../../libs/form";
import { useDependentUnitTypeOptions } from "../../../hooks/useDependentUnitTypeOptions";

type UnitTypeFieldsProps = {
  colSpan?: number;
};

export const UnitTypeFields = (props: UnitTypeFieldsProps) => {
  const { colSpan } = props;

  const { control, formState } = useFormContext();
  const { errors } = formState;

  const {
    isLoadingPropertyTypes,
    hasUsageTypeSelected,
    hasUnitTypeSelected,
    usageTypeOptions,
    unitTypeOptions,
    unitSubTypeOptions,
  } = useDependentUnitTypeOptions({ shouldPrefillFromUnitData: false });

  return (
    <>
      <Col span={colSpan || 6}>
        <ReactSelectField
          label="Usage Type"
          fieldname="usagesType"
          control={control}
          selectOption={usageTypeOptions}
          {...getValidationProps({ fieldName: "usagesType", errors, isRequired: true })}
          iProps={{
            placeholder: getSelectPlaceholderMessage("usagesType"),
            isLoading: isLoadingPropertyTypes,
            isDisabled: isLoadingPropertyTypes,
          }}
        />
      </Col>

      <Col span={colSpan || 6}>
        <ReactSelectField
          label="Unit Type"
          fieldname="unitType"
          control={control}
          selectOption={unitTypeOptions}
          {...getValidationProps({ fieldName: "unitType", errors, isRequired: true })}
          iProps={{
            placeholder: getSelectPlaceholderMessage("unitType"),
            isDisabled: !hasUsageTypeSelected,
          }}
        />
      </Col>

      <Col span={colSpan || 6}>
        <ReactSelectField
          isRequired
          label="Unit Sub Type"
          fieldname="unitSubType"
          control={control}
          selectOption={unitSubTypeOptions}
          {...getValidationProps({ fieldName: "unitSubType", errors, isRequired: true })}
          iProps={{
            placeholder: getSelectPlaceholderMessage("unitSubType"),
            isDisabled: !hasUnitTypeSelected,
          }}
        />
      </Col>
    </>
  );
};
